import { Component, OnInit, ChangeDetectorRef, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FirebaseListObservable, AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Router } from "@angular/router";
import { TranslateService } from "ng2-translate";
import { NotificationService } from "../_services/notification.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../environments/environment';
import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';
import { LoaderService } from '../_services/loader.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { MetaService } from 'ng2-meta';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserComponent implements OnInit {
  posts: any;
  user: any;
  followPath: string;
  currentUser: any;
  product: FirebaseListObservable<any[]>;
  userId = localStorage.getItem('currentUserId');
  choosePage: boolean = true;
  following: any;
  isFavorites = false;
  followId: string;
  model: any;
  welcomePost = [];
  control = false;
  ipAddress: any;
  @Input() username;
  private subscription: Subscription = new Subscription();
  status: any = {};
  subsc: any;
  constructor(
    private router: Router,
    public translate: TranslateService,
    private loader: LoaderService,
    private dialog: MatDialog,
    private afs: AngularFirestore,
    public notificationService: NotificationService,
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private _http: Http,
    private userService: UserService,
    private metaService: MetaService
  ) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.currentUser = user;
      this.cd.markForCheck();
    }));



  }

  editProfile() {
    this.router.navigate(["/profile-update"]);
  }
  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  action(functionName) {
    this[functionName]();
  }
  ngOnInit() {
    this.getIpAdress();
    this.cd.detectChanges();

  }

  async ngOnChanges(changes: SimpleChanges) {

    try {
    } catch (e) {

    }

    await this.subscription.add(this.afs.collection('users', ref => ref
      .where('username', '==', this.username)).snapshotChanges().pipe().map(user => {
        return user.map(users => {
          return {
            id: users.payload.doc.id,
            ...users.payload.doc.data()
          }
        })
      }).subscribe(user => {
        this.user = user[0];


        this.user['badges'] = this.user['badges'] ? Object.keys(this.user['badges']) : [];
        if (this.currentUser && this.currentUser.username == this.username) {
          this.status.font = "fa-pencil-square";
          this.status.buttonText = "Profilini Düzenle";
          this.status.callbackFunction = "editProfile";
          this.status.thisUsersAre = "Same";
        }

        this.afs.collection('users').doc(user[0].id).collection('followEr').doc(this.userId).ref.onSnapshot((userData => {

          if (userData.exists) {

            this.status.font = "fa-user-times";
            this.status.buttonText = "Takibi Bırak";
            this.status.callbackFunction = "unFollow";
            this.status.thisUsersAre = "Friend";
            this.cd.markForCheck();

          }

          this.afs.collection('users').doc(user[0].id).collection('requests').doc(this.userId).ref.onSnapshot((data) => {
            if (data.exists) {
              this.status.font = "fa-user-times";
              this.status.buttonText = "İsteği İptal Et";
              this.status.callbackFunction = "cancelRequest";
              this.status.thisUsersAre = "ToBeFriends";
              this.cd.markForCheck();

            }
            if (!userData.exists && !data.exists && this.currentUser.username !== this.username) {
              this.metaService.setTitle(this.user.firstname + ' ' + this.user.lastname + ' '
                + '(' + '@' + this.user.username + ')' + ' - Kullanıcı Yorumları | bigadvice.com');
              this.metaService.setTag('description', this.user.firstname + ' '
                + this.user.lastname + ' ' + "adlı kullanıcının bigadvice'taki müşteri şikayet, görüş ve öneri paylaşımlarını gör");
              this.status.font = "fa-user-plus";
              this.status.buttonText = "Takip Et";
              this.status.callbackFunction = "follow";
              this.status.thisUsersAre = "Not Friend";
              this.cd.markForCheck();

            }

          })

        }))


        this.cd.markForCheck();

      }))



  }

  open(content) {
    this.modalService.open(content);
  }

  silencedUser() {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    const { firstname, lastname, username, profileImage } = this.user;
    this.afs.collection('users').doc(this.userId).collection('silencedUser').doc(this.user.id).set({
      username: username,
      firstname: firstname,
      lastname: lastname,
      profileImage: profileImage,
      userKey: this.user.id

    }).then(() => {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Kullanıcıyı sessize aldın.",
          type: "update"
        }
      });
    });
  }

  complaintUser(user) {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    const { firstname, lastname, username, profileImage } = this.user;
    this.afs.collection('complaints').doc(this.user.id).ref.get().then((snap => {
      if (!snap.exists) {
        this.afs.collection('complaints').doc(this.user.id).set({
          username: username,
          firstname: firstname,
          lastname: lastname,
          profileImage: profileImage,
          modifyDate: Date.now(),
          type: 'user-complaints'

        }).then(() => {
          this.afs.collection('complaints').doc(this.user.id).collection('users').doc(this.userId).set({
            username: this.currentUser.username,
            firstname: this.currentUser.firstname,
            lastname: this.currentUser.lastname,
            key: this.currentUser.id,
            modifyDate: Date.now()

          })
        })

      }
      else {
        this.afs.collection('complaints').doc(user.id).collection('users').doc(this.userId).set({
          username: this.currentUser.username,
          firstname: this.currentUser.firstname,
          lastname: this.currentUser.lastname,
          key: this.currentUser.id,
          modifyDate: Date.now()

        })


      }
    }))
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: "Şikayetin iletilmiştir.",
        type: "update"
      }
    });

  }

  getFollowing(type) {

    this.choosePage = false;
    this.isFavorites = false;
    this.followPath = 'followIng';
    this.following = this.user.id;
    this.cd.markForCheck();

  }
  getFollowers() {
    this.choosePage = false;
    this.isFavorites = false;
    this.following = this.user.id;
    this.followPath = 'followEr'
    this.cd.markForCheck();
  }

  byHashtag(hashtag) {
    this.control = true;

    if (hashtag == "myPosts") {
      this.isFavorites = false;
      this.choosePage = true;
      // this.posts = 'users/' + this.user.$key + '/' + hashtag;
    } else if (hashtag == "followingPosts") {
      this.isFavorites = true;
      this.choosePage = false;
    } else {
      // this.posts = 'users/' + this.user.$key + '/hashtags/' + hashtag + '/timeline';

      this.isFavorites = false;
    }


  }

  async cancelRequest() {
    this.afs.collection('users').doc(this.user.id).collection('requests').doc(this.currentUser.id).delete();
    await this.afs.collection('users').doc(this.currentUser.id).collection('requests').doc(this.user.id).delete();
    await this.afs.collection('users').doc(this.user.id).collection('friendRequests').doc(this.currentUser.id).delete();
  }

  async unFollow() {
    this.afs.collection('users').doc(this.user.id)
      .update({ followErCount: this.user.followErCount ? this.user.followErCount - 1 : 0 })
    await this.afs.collection('users').doc(this.userId).update({
      followIngCount: this.currentUser.followIngCount
        ? this.currentUser.followIngCount - 1 : 0
    }).then(() => {
      this.userService.userLog('unFollow', this.ipAddress);
    })
    await this.afs.collection('users').doc(this.user.id).collection('followEr').doc(this.userId).delete();
    await this.afs.collection('users').doc(this.userId).collection('followIng').doc(this.user.id).delete();

  }

  async follow() {

    if (this.userId) {
      if (!this.user.isSecret) {

        await this.afs.collection('users').doc(this.user.id)
          .update({ followErCount: this.user.followErCount ? this.user.followErCount + 1 : 1 });
        await this.afs.collection('users').doc(this.userId)
          .update({ followIngCount: this.currentUser.followIngCount ? this.currentUser.followIngCount + 1 : 1 });

        await this.afs.collection('users').doc(this.user.id).collection('followEr').doc(this.userId).set({
          firstname: this.currentUser.firstname,
          lastname: this.currentUser.lastname,
          email: this.currentUser.email,
          username: this.currentUser.username,
          profileImage: this.currentUser.profileImage,
          isSecret: this.currentUser.isSecret,
          id: this.currentUser.id,
          type: "user"
        }).then(() => {
          this.afs.collection('users').doc(this.userId).collection('followIng').doc(this.user.id).set({
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            email: this.user.email,
            username: this.user.username,
            profileImage: this.user.profileImage,
            isSecret: this.user.isSecret,
            id: this.user.id,
            type: "user"

          })
        }).then(() => {
          this.userService.userLog('follow', this.ipAddress);
        })
        const message = {
          body: '<span><strong>' + this.currentUser.firstname + ' ' + this.currentUser.lastname
            + '</strong> seni takip etmeye başladı. Profilini gör!<span>',
          innerBody: this.currentUser.firstname + ' ' + this.currentUser.lastname + ' seni takip etmeye başladı. Profilini gör!',
          title: 'Arkadaşlık',
          image: this.currentUser.profileImage,
          isUnseen: true,
          action: this.currentUser.username,
          click_action: environment.domainName + "/" + this.currentUser.username,
          modifyDate: Date.now()
        };
        this.notificationService.pushNotification(message, this.user.id);
        this.cd.markForCheck();
      }
      else {
        this.notificationService.pushFriendRequest(this.user.id, this.userId);
        this.userService.userLog('follow-request', this.ipAddress);
      }

    } else {
      this.router.navigate(['/auth'])
    }

  }
  ngOnDestroy() {
    if (this.user.isSecret) {
      this.loader.load(false);
    }
    try {
      this.subscription.unsubscribe();
    } catch (e) { }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/user/user.component.ts